// Regex to validate only decimal numbers with comma
export const inputDecimalNumberRegex = /^(\d+)((\d+)|((,\d+)?))?$/

export const decimalNumberValidationMessage =
  'Introduzca un número con formato 0,00'
